import { z } from "zod/v4"
import type { DocumentSnapshotLike } from "../firestore"
import { AdminInviteId } from "../id"
import { AdminPermission } from "./admin"

export const AdminInviteMeta = z.object({
  email: z.email(),
  permission: AdminPermission
})

export type AdminInviteMeta = z.infer<typeof AdminInviteMeta>

export const AdminInviteDocumentBody = z.intersection(
  AdminInviteMeta,
  z.object({
    created_at: z.number(),
    updated_at: z.number()
  })
)

export type AdminInviteDocumentBody = z.infer<typeof AdminInviteDocumentBody>

export type AdminInviteDocument = AdminInviteDocumentBody & {
  id: AdminInviteId
}

export class AdminInviteDocuments {
  static toDocumentData(doc: AdminInviteDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): AdminInviteDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: AdminInviteId(doc.id),
      email: data["email"],
      // 過去に作られたAdminは当面の間、全権限保持者として取り扱う
      permission: data["permission"] ?? { kind: "all" },
      created_at: data["created_at"],
      updated_at: data["updated_at"]
    }
  }
}

export const AdminInviteCreateRequest = z.object({
  email: z.email(),
  permission: AdminPermission
})

export type AdminInviteCreateRequest = z.infer<typeof AdminInviteCreateRequest>

export const ResolveAdminEmailRequest = z.object({
  ids: z.array(z.string())
})
